import { z } from "zod";

export const campaign = z.object({
  active: z.boolean(),
});
